import { ReactNode, Fragment, useState, useEffect } from "react";
import { Flex, Theme } from "theme-ui";
import "./layout-base.css";
import { GooglePPCHeader } from "./Affiliates";
import { Footer } from "./Footer";
import { WebAnalytics } from "../components/SEO";

export interface GooglePPCLayoutProps {
  children: ReactNode;
  className?: string;
  hideMasterDisclaimers?: boolean;
  disclaimers?: (string | ReactNode)[];
  headerCta?: JSX.Element;
}

export const GooglePPCLayout = ({
  children,
  className,
  hideMasterDisclaimers,
  disclaimers,
  headerCta,
}: GooglePPCLayoutProps) => {
  const [onLoad, setOnLoad] = useState(false);
  useEffect(() => {
    setOnLoad(true);
  }, []);

  return (
    <>
      {onLoad && (
        <link
          href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          rel="stylesheet"
        />
      )}
      <Flex
        className={className}
        sx={{
          bg: "grays.0",
          fontFamily: "body",
          flexDirection: "column",
          overflow: "visible",
        }}
      >
        <GooglePPCHeader cta={headerCta} />
        <main>{children}</main>
        <Footer
          hideFooterLinks={true}
          hideMasterDisclaimers={hideMasterDisclaimers}
          disclaimers={disclaimers}
        />
      </Flex>
      <WebAnalytics />
    </>
  );
};
